import React from 'react';
import { Badge } from '@components/ui/badge';
import { cn } from '@core/utils/cn';
import { WorkoutFlagStatus } from '../../../../core/api/FitnessActivityClient';

interface FlagBadgeProps {
    status: WorkoutFlagStatus;
    size?: 'small' | 'medium';
    onClick?: () => void;
}

const flagVariants: Record<
    string,
    'destructive' | 'warning' | 'success' | 'info'
> = {
    [WorkoutFlagStatus.FRAUD]: 'destructive',
    [WorkoutFlagStatus.SUSPICIOUS]: 'warning',
    [WorkoutFlagStatus.NOT_FRAUD]: 'success'
};

export function FlagBadge({ status, size = 'small', onClick }: FlagBadgeProps) {
    return (
        <Badge
            variant={flagVariants[status] ?? 'info'}
            onClick={onClick}
            className={cn(
                'font-semibold tracking-wide',
                size === 'small' ? 'text-[0.65rem]' : 'px-3 py-1',
                onClick && 'cursor-pointer'
            )}
        >
            {status}
        </Badge>
    );
}
